import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/banner-top-post-work.png'
import _imports_1 from '@/assets/img/banner-top-post-work-sp.png'


const _withScopeId = n => (_pushScopeId("data-v-25df05f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sw-post-work-banner--image-pc d-none d-sm-block",
  src: _imports_0,
  alt: "アカウントを作成する"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sw-post-work-banner--image-sp d-block d-sm-none",
  src: _imports_1,
  alt: "アカウントを作成する"
}, null, -1))

import useUsersFunc from '@/components/utils/UsersUtil';
import {
  computed, inject,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwCreateAccountBanner',
  setup(__props) {

const userUtil = useUsersFunc();

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-post-work-banner': true,
}));


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_unref(userUtil).isLoggedIn())
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_unref(classes))
      }, [
        _createVNode(_component_router_link, { to: "/signup" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        })
      ], 2))
    : _createCommentVNode("", true)
}
}

})